import React, { Component } from "react";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import { LegalHeirsVerify } from "./sopDataTemplate";
import DataModel from "./sopDataModel";

interface AllProps {
  data: LegalHeirsVerify;
  handleLegalHerisChange: any;
}
export class LegalHerisVerification extends Component<AllProps> {
  state = {
    isOptionOpen: false,
    bgColor: "#ffff8d",
    responseData: {},
    isUpdateAvailable: false,
  };

  componentDidMount() {
    const { data } = this.props;
    this.setState({
      responseData: JSON.parse(JSON.stringify(data)),
    });
  }

  changeBgColor = () => {
    const { bgColor } = this.state;
    if (bgColor !== "lightgreen") {
      this.setState({ bgColor: "lightgreen" });
    }
  };
  handleChange = (e) => {
    const { data } = this.props;
    data[e.target.name] = e.target.value;
    this.changeBgColor();
    data.bgColor = "lightgreen";
    this.props.handleLegalHerisChange(data);
  };

  handleChildInputChange = (key, name, value, index?) => {
    const { data } = this.props;
    if (index !== undefined) data[key][index][name] = value;
    else data[key][name] = value;
    this.changeBgColor();
    data.bgColor = "lightgreen";
    this.props.handleLegalHerisChange(data);
    this.setState({
      isUpdateAvailable: !this.state.isUpdateAvailable,
    });
  };
  handleChildRadioChange = (key, name, val, index?) => {
    const { data } = this.props;
    if (index !== undefined) {
      data[key][index][name] = val;
    } else {
      data[key][name] = val;
    }
    this.changeBgColor();
    data.bgColor = "lightgreen";
    this.props.handleLegalHerisChange(data);
    this.setState({
      isUpdateAvailable: !this.state.isUpdateAvailable,
    });
  };

  checkOperation = (type, value, index) => {
    let isEditable = false;
    const { responseData } = this.state;
    if (responseData[type] && responseData[type].length < index + 1) {
      isEditable = true;
    }
    return isEditable;
  };

  addChild = (type) => {
    const { data } = this.props;
    data[type].push({
      legalHeirsWithin13: false,
      docNoAndYear: "",
      nextDeedDocNoAndYear: "",
      legalHeirsObtained: "",
      geanology: "",
    });
    this.props.handleLegalHerisChange(data);
    this.setState({
      isUpdateAvailable: !this.state.isUpdateAvailable,
    });
  };

  removeChild = (type, index) => {
    const { data } = this.props;
    delete data[type][index];
    const updatedLegalHeirs = data[type].filter((item) => item !== null); // Filter out null elements
    data[type] = updatedLegalHeirs;
    this.props.handleLegalHerisChange(data);
    this.setState({
      isUpdateAvailable: !this.state.isUpdateAvailable,
    });
  };

  getAddButton = (
    title: string,
    value: string,
    showRadioForSection?: boolean,
  ) => {
    const { data } = this.props;

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <h6 style={{ margin: 0 }}>
            <b>{title}</b>
          </h6>

          {/* Show radio buttons only for the specified section */}
          {showRadioForSection === true && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginLeft: "20px",
              }}
            >
              <Form.Check
                inline
                label="Yes"
                name={`isshow${value}Status`}
                type="radio"
                id={`isshow${value}Status-yes`}
                checked={data[`isshow${value}Status`] === true}
                onChange={() => {
                  const fieldName = `isshow${value}Status`;
                  data[fieldName] = true;
                  this.changeBgColor();
                  data.bgColor = "lightgreen";
                  this.props.handleLegalHerisChange(data);
                  this.setState({
                    isUpdateAvailable: !this.state.isUpdateAvailable,
                  });
                }}
                style={{ marginRight: "15px" }}
              />
              <Form.Check
                inline
                label="No"
                name={`isshow${value}Status`}
                type="radio"
                id={`${value}Status-no`}
                checked={data[`isshow${value}Status`] !== true}
                onChange={() => {
                  const fieldName = `isshow${value}Status`;
                  data[fieldName] = false;
                  this.changeBgColor();
                  data.bgColor = "lightgreen";
                  this.props.handleLegalHerisChange(data);
                  this.setState({
                    isUpdateAvailable: !this.state.isUpdateAvailable,
                  });
                }}
              />
            </div>
          )}
        </div>

        <div onClick={() => this.addChild(value)}>
          <button
            className="btn btn-sm btn-primary"
            style={{ fontSize: "smaller" }}
          >
            Add {title}
          </button>
        </div>
      </div>
    );
  };
  render() {
    const { data } = this.props;
    const { isOptionOpen, bgColor } = this.state;
    return (
      <div className="collapse-section legal-heris-verify">
        <Accordion>
          <Card>
            <Accordion.Toggle
              style={{ background: data.bgColor ? data.bgColor : bgColor }}
              as={Card.Header}
              eventKey="3"
              onClick={() => {
                this.setState({ isOptionOpen: !isOptionOpen });
              }}
            >
              <h5>
                <b>Legal Heirs Verification</b>
              </h5>
              <i
                className={`icon feather icon-${!isOptionOpen ? "plus" : "minus"}`}
                style={{
                  color: "black",
                  fontSize: "17px",
                  fontWeight: "bold",
                  float: "right",
                }}
              />
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="3">
              <Card.Body>
                <div>
                  {this.getAddButton(
                    "Legal Heirs",
                    "legalHeirs",
                    true
                  )}
                  {data.legalHeirs &&
                    Array.isArray(data.legalHeirs) &&
                    data.legalHeirs.map((value, index) => {
                      return (
                        <div className="row">
                          <div className="form-group  col-md-9">
                            <label
                              className="label mb-3"
                              style={{ padding: 0 }}
                            >
                              Predeceased Son/Daughter Legal Heirs Verified
                            </label>
                          </div>
                          <div className="form-group  col-md-3">
                            <div className="row" style={{ marginLeft: 0 }}>
                              <Form.Check
                                inline
                                label="Yes"
                                name={
                                  "PredeceasedlegalHeire" +
                                  (value && value.PredeceasedlegalHeire
                                    ? value.PredeceasedlegalHeire
                                    : "") +
                                  index
                                }
                                type="radio"
                                checked={
                                  value &&
                                  value.PredeceasedlegalHeire !== null &&
                                  value.PredeceasedlegalHeire !== undefined
                                    ? value.PredeceasedlegalHeire
                                    : false
                                }
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "legalHeirs",
                                    "PredeceasedlegalHeire",
                                    true,
                                    index,
                                  )
                                }
                              />
                              <Form.Check
                                inline
                                label="No"
                                name={
                                  "PredeceasedlegalHeire" +
                                  (value && !value.PredeceasedlegalHeire
                                    ? !value.PredeceasedlegalHeire
                                    : "") +
                                  index
                                }
                                type="radio"
                                checked={
                                  value &&
                                  value.PredeceasedlegalHeire !== null &&
                                  value.PredeceasedlegalHeire !== undefined
                                    ? !value.PredeceasedlegalHeire
                                    : false
                                }
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "legalHeirs",
                                    "PredeceasedlegalHeire",
                                    false,
                                    index,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group  col-md-9">
                            <label
                              className="label mb-3"
                              style={{ padding: 0 }}
                            >
                              Does Legal Hiers Come Within 13 Years Tracing
                              Period From Till Date?
                            </label>
                          </div>
                          <div className="form-group  col-md-3">
                            <div className="row" style={{ marginLeft: 0 }}>
                              <Form.Check
                                inline
                                label="Yes"
                                name={
                                  "legalHeirsWithin13" +
                                  (value && value.legalHeirsWithin13
                                    ? value.legalHeirsWithin13
                                    : "") +
                                  index
                                }
                                type="radio"
                                checked={
                                  value &&
                                  value.legalHeirsWithin13 !== null &&
                                  value.legalHeirsWithin13 !== undefined
                                    ? value.legalHeirsWithin13
                                    : false
                                }
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "legalHeirs",
                                    "legalHeirsWithin13",
                                    true,
                                    index,
                                  )
                                }
                              />
                              <Form.Check
                                inline
                                label="No"
                                name={
                                  "legalHeirsWithin13" +
                                  (value && !value.legalHeirsWithin13
                                    ? !value.legalHeirsWithin13
                                    : "") +
                                  index
                                }
                                type="radio"
                                checked={
                                  value &&
                                  value.legalHeirsWithin13 !== null &&
                                  value.legalHeirsWithin13 !== undefined
                                    ? !value.legalHeirsWithin13
                                    : false
                                }
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "legalHeirs",
                                    "legalHeirsWithin13",
                                    false,
                                    index,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group col-md-5">
                            <label className="label" style={{ padding: 0 }}>
                              Legal Heirs Certificate Number &amp; Year
                            </label>
                            <input
                              className="form-control"
                              name={
                                "docNoAndYear" +
                                (value && value.docNoAndYear
                                  ? value.docNoAndYear
                                  : "") +
                                index
                              }
                              type="text"
                              value={
                                value && value.docNoAndYear
                                  ? value.docNoAndYear
                                  : ""
                              }
                              onChange={(e) =>
                                this.handleChildInputChange(
                                  "legalHeirs",
                                  "docNoAndYear",
                                  e.target.value,
                                  index,
                                )
                              }
                            />
                          </div>

                          <div className="form-group col-md-6">
                            <label className="label" style={{ padding: 0 }}>
                              Next Deed's(After Died) Doc No &amp; Year
                            </label>
                            <input
                              className="form-control"
                              name={
                                "nextDeedDocNoAndYear" +
                                (value && value.nextDeedDocNoAndYear
                                  ? value.nextDeedDocNoAndYear
                                  : "") +
                                index
                              }
                              type="text"
                              value={
                                value && value.nextDeedDocNoAndYear
                                  ? value.nextDeedDocNoAndYear
                                  : ""
                              }
                              onChange={(e) =>
                                this.handleChildInputChange(
                                  "legalHeirs",
                                  "nextDeedDocNoAndYear",
                                  e.target.value,
                                  index,
                                )
                              }
                            />
                          </div>
                          {this.checkOperation("legalHeirs", value, index) && (
                            <div
                              className="form-group col-md-1"
                              style={{
                                alignSelf: "center",
                                fontSize: "initial",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                this.removeChild("legalHeirs", index)
                              }
                            >
                              <i
                                style={{ color: "red" }}
                                className="feather icon-minus-circle"
                              />
                            </div>
                          )}
                          <div className="form-group col-md-5">
                            <label className="label" style={{ padding: 0 }}>
                              Legal Heirs Obtained From
                            </label>
                            <input
                              className="form-control"
                              name={
                                "legalHeirsObtained" +
                                (value && value.legalHeirsObtained
                                  ? value.legalHeirsObtained
                                  : "") +
                                index
                              }
                              type="text"
                              value={
                                value && value.legalHeirsObtained
                                  ? value.legalHeirsObtained
                                  : ""
                              }
                              onChange={(e) =>
                                this.handleChildInputChange(
                                  "legalHeirs",
                                  "legalHeirsObtained",
                                  e.target.value,
                                  index,
                                )
                              }
                            />
                          </div>
                          <div className="form-group col-md-6">
                            <label className="label" style={{ padding: 0 }}>
                              Genealogy Obtained from
                            </label>
                            <input
                              className="form-control"
                              name={
                                "geanology" +
                                (value && value.geanology
                                  ? value.geanology
                                  : "") +
                                index
                              }
                              type="text"
                              value={
                                value && value.geanology ? value.geanology : ""
                              }
                              onChange={(e) =>
                                this.handleChildInputChange(
                                  "legalHeirs",
                                  "geanology",
                                  e.target.value,
                                  index,
                                )
                              }
                            />
                          </div>
                          <div className="form-group col-md-6">
                            <label className="label" style={{ padding: 0 }}>
                              Legal Heir Certificate Verified with QR Code
                            </label>
                            <div className="form-group  col-md-3">
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={
                                    "legalHeirsWithqrcode" +
                                    (value && value.legalHeirsWithqrcode
                                      ? value.legalHeirsWithqrcode
                                      : "") +
                                    index
                                  }
                                  type="radio"
                                  checked={
                                    value &&
                                    value.legalHeirsWithqrcode !== null &&
                                    value.legalHeirsWithqrcode !== undefined
                                      ? value.legalHeirsWithqrcode
                                      : false
                                  }
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "legalHeirs",
                                      "legalHeirsWithqrcode",
                                      true,
                                      index,
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={
                                    "legalHeirsWithqrcode" +
                                    (value && !value.legalHeirsWithqrcode
                                      ? !value.legalHeirsWithqrcode
                                      : "") +
                                    index
                                  }
                                  type="radio"
                                  checked={
                                    value &&
                                    value.legalHeirsWithqrcode !== null &&
                                    value.legalHeirsWithqrcode !== undefined
                                      ? !value.legalHeirsWithqrcode
                                      : false
                                  }
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "legalHeirs",
                                      "legalHeirsWithqrcode",
                                      false,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </div>
                          <div className="form-group col-md-6">
                            <label className="label" style={{ padding: 0 }}>
                              Attached Proof Submitted for Verified QR Code
                            </label>
                            <div className="form-group  col-md-3">
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={
                                    "legalHeirsattacedproof" +
                                    (value && value.legalHeirsattacedproof
                                      ? value.legalHeirsattacedproof
                                      : "") +
                                    index
                                  }
                                  type="radio"
                                  checked={
                                    value &&
                                    value.legalHeirsattacedproof !== null &&
                                    value.legalHeirsattacedproof !== undefined
                                      ? value.legalHeirsattacedproof
                                      : false
                                  }
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "legalHeirs",
                                      "legalHeirsattacedproof",
                                      true,
                                      index,
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={
                                    "legalHeirsattacedproof" +
                                    (value && !value.legalHeirsattacedproof
                                      ? !value.legalHeirsattacedproof
                                      : "") +
                                    index
                                  }
                                  type="radio"
                                  checked={
                                    value &&
                                    value.legalHeirsattacedproof !== null &&
                                    value.legalHeirsattacedproof !== undefined
                                      ? !value.legalHeirsattacedproof
                                      : false
                                  }
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "legalHeirs",
                                      "legalHeirsattacedproof",
                                      false,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      </div>
    );
  }
}

export default LegalHerisVerification;
